export const ADD_SUBSCRIPTION = 'ADD_SUBSCRIPTION'
export const REPLACE_SUBSCRIPTION = 'REPLACE_SUBSCRIPTION'
export const CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION'
export const CLEAR_SUBSCRIPTIONS = 'CLEAR_SUBSCRIPTIONS'
export const LAST_PAYMENT_FAIL_INFO = 'LAST_PAYMENT_FAIL_INFO'



// WEBPACK FOOTER //
// ./src/common/store/Subscriptions/types.js